import api from '../../components/api'
import { JobNumberingSettings, SaveJobNumberingSettingsRequest } from './jobNumbering'

export const getJobNumberingSettings = async (): Promise<JobNumberingSettings> =>
  (await api.get<JobNumberingSettings>('/web/job-numbering')).data

export const saveJobNumberingSettings = async (request: SaveJobNumberingSettingsRequest): Promise<JobNumberingSettings> =>
  (await api.put<JobNumberingSettings>('/web/job-numbering', request)).data
